"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bodyScrollLock = require("body-scroll-lock");
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility']),
  className = _CssClassNames.className;

// TODO: This is really ugly
var allowClose = true;
var modalsOpen = 0;
var Modal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Modal, _PureComponent);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      preShow: false,
      show: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      if (!allowClose) {
        allowClose = true;
        return;
      }
      if (_this.state.show) {
        _this.setState({
          show: false
        });
        setTimeout(function () {
          _this.setState({
            preShow: false
          });
        }, 400);
      } else {
        _this.setState({
          preShow: true
        });
        setTimeout(function () {
          _this.setState({
            show: _this.state.preShow
          });
        }, 400);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFromBackground", function () {
      if (_this.props.disableBackgroundClose) {
        return;
      }
      _this.toggle();
    });
    _defineProperty(_assertThisInitialized(_this), "unallowClose", function () {
      if (_this.props.disableBackgroundClose) {
        return;
      }
      allowClose = false;
    });
    _this.modalRef = null;
    return _this;
  }
  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (typeof window !== 'undefined') {
        if (this.state.preShow && !prevState.preShow) {
          window.document.body.setAttribute('data-modal-open', 'true');
        } else if (!this.state.preShow && prevState.preShow && !modalsOpen) {
          window.document.body.removeAttribute('data-modal-open');
        }
      }
      if (this.state.show !== prevState.show) {
        if (this.state.show) {
          modalsOpen += 1;
          if (this.modalRef) {
            (0, _bodyScrollLock.disableBodyScroll)(this.modalRef);
          }
        } else {
          modalsOpen -= 1;
          allowClose = true;
          if (this.modalRef) {
            (0, _bodyScrollLock.enableBodyScroll)(this.modalRef);
          }
          if (!modalsOpen) {
            (0, _bodyScrollLock.clearAllBodyScrollLocks)();
          }
        }
        if (this.props.onToggle) {
          this.props.onToggle(this.state.show);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.show) {
        if (this.modalRef) {
          (0, _bodyScrollLock.enableBodyScroll)(this.modalRef);
          window.document.body.removeAttribute('data-modal-open');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        show = _this$state.show,
        preShow = _this$state.preShow;
      var _this$props = this.props,
        children = _this$props.children,
        _this$props$header = _this$props.header,
        header = _this$props$header === void 0 ? null : _this$props$header,
        _this$props$footer = _this$props.footer,
        footer = _this$props$footer === void 0 ? null : _this$props$footer,
        _this$props$wrapperCl = _this$props.wrapperClassName,
        wrapperClassName = _this$props$wrapperCl === void 0 ? '' : _this$props$wrapperCl,
        _this$props$closeButt = _this$props.closeButtonClassName,
        closeButtonClassName = _this$props$closeButt === void 0 ? '' : _this$props$closeButt,
        _this$props$contentCl = _this$props.contentClassName,
        contentClassName = _this$props$contentCl === void 0 ? '' : _this$props$contentCl,
        _this$props$bodyClass = _this$props.bodyClassName,
        bodyClassName = _this$props$bodyClass === void 0 ? '' : _this$props$bodyClass,
        _this$props$dialogCla = _this$props.dialogClassName,
        dialogClassName = _this$props$dialogCla === void 0 ? '' : _this$props$dialogCla,
        _this$props$headerCla = _this$props.headerClassName,
        headerClassName = _this$props$headerCla === void 0 ? '' : _this$props$headerCla,
        _this$props$footerCla = _this$props.footerClassName,
        footerClassName = _this$props$footerCla === void 0 ? '' : _this$props$footerCla,
        _this$props$showClass = _this$props.showClassName,
        showClassName = _this$props$showClass === void 0 ? '' : _this$props$showClass,
        size = _this$props.size;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, preShow ? /*#__PURE__*/_react["default"].createElement("div", className("modal-backdrop backdrop-fade-opacity ".concat(show ? 'show' : ''))) : null, /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: function ref(el) {
          return _this2.modalRef = el;
        }
      }, className("modal fade fade-opacity ".concat(wrapperClassName, " ").concat(show ? 'show' : '', " ").concat(show && showClassName ? showClassName : '')), {
        tabIndex: "-1",
        onClick: this.toggleFromBackground,
        onKeyDown: this.toggleFromBackground,
        style: preShow ? {
          display: 'block'
        } : {},
        role: "dialog"
      }), /*#__PURE__*/_react["default"].createElement("div", _extends({
        onClick: this.unallowClose,
        onKeyDown: this.unallowClose
      }, className("modal-dialog modal-dialog-centered modal-".concat(size ? size : 'lg', " ").concat(dialogClassName)), {
        role: "document"
      }), /*#__PURE__*/_react["default"].createElement("div", className("modal-content ".concat(contentClassName)), header ? /*#__PURE__*/_react["default"].createElement("div", className("modal-header ".concat(headerClassName)), header, /*#__PURE__*/_react["default"].createElement("button", _extends({
        type: "button",
        "data-dismiss": "modal",
        onClick: this.toggle,
        "aria-label": "Close"
      }, className(closeButtonClassName)), /*#__PURE__*/_react["default"].createElement("span", null, "\xD7"))) : null, children ? /*#__PURE__*/_react["default"].createElement("div", className("modal-body ".concat(bodyClassName)), children) : null, footer ? /*#__PURE__*/_react["default"].createElement("div", className("modal-footer justify-content-center ".concat(footerClassName)), footer) : null))));
    }
  }]);
  return Modal;
}(_react.PureComponent);
exports.Modal = Modal;